export const UploadLogoIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={`upload-logo-icon ${className || ""}`}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="currentColor">
          <g clip-path="url(#clip0_upload_logo)">
            <path d="M10.382 2.98839C6.28875 2.98839 2.96542 6.31172 2.96542 10.4049C2.96542 14.4982 6.28875 17.8215 10.382 17.8215C14.4753 17.8215 17.7987 14.4982 17.7987 10.4049C17.7987 6.31172 14.4753 2.98839 10.382 2.98839ZM10.382 16.155C7.21208 16.155 4.63208 13.575 4.63208 10.4049C4.63208 7.23495 7.21208 4.65495 10.382 4.65495C13.552 4.65495 16.132 7.23495 16.132 10.4049C16.132 13.575 13.552 16.155 10.382 16.155Z" />
            <path d="M10.382 7.98839C10.7971 7.98839 11.132 7.65349 11.132 7.23839V6.48839C11.132 6.07328 10.7971 5.73839 10.382 5.73839C9.96692 5.73839 9.63203 6.07328 9.63203 6.48839V7.23839C9.63203 7.65349 9.96692 7.98839 10.382 7.98839Z" />
            <path d="M7.21875 10.4049C7.21875 10.82 7.55364 11.1549 7.96875 11.1549H9.63197V13.8215C9.63197 14.2367 9.96686 14.5715 10.382 14.5715C10.7971 14.5715 11.132 14.2367 11.132 13.8215V11.1549H12.7952C13.2103 11.1549 13.5452 10.82 13.5452 10.4049C13.5452 9.98983 13.2103 9.65495 12.7952 9.65495H11.132V7.73839C11.132 7.32328 10.7971 6.98839 10.382 6.98839C9.96686 6.98839 9.63197 7.32328 9.63197 7.73839V9.65495H7.96875C7.55364 9.65495 7.21875 9.98983 7.21875 10.4049Z" />
          </g>
          <defs>
            <clipPath id="clip0_upload_logo">
              <rect width="20" height="20" fill="white" transform="translate(0.38208 0.988403)"/>
            </clipPath>
          </defs>
        </svg>
      `,
      }}
    />
  );
};

export default UploadLogoIcon;
